import axios from "axios";

export default {
  namespaced: true,

  state: {
    esbdError: false,
    requestError: false,
    errorMessage: ''
  },

  getters: {
    getEsbdError: (state) => state.esbdError,
    getRequestError: (state) => state.requestError,
    getErrorMessage: (state) => state.errorMessage
  },

  actions: {
    init({ commit, dispatch }) {
      dispatch('getEsbdError');
      commit('SET_REQUEST_ERROR', false);
    },

    getEsbdError({ commit }) {
      axios.get("/esbdsettings/get/status").then(result => {
        commit('SET_ESBD_ERROR', result.data.data === 1)
      });
    },

    async setEsbdError({ commit }, flag) {
      commit('SET_REQUEST_ERROR', false);

      const data = {
        esbd_error: flag ? 1 : 0
      };

      try {
        const result = await axios.post("/esbdsettings/set/status", data);

        if (result.data.success) {
          commit('SET_ESBD_ERROR', flag);
        } else {
          commit('SET_REQUEST_ERROR', true);
          commit('SET_ERROR_MESSAGE', 'Во время запроса произошла ошибка');
        }
      } catch (e) {
        commit('SET_REQUEST_ERROR', true);
        commit('SET_ERROR_MESSAGE', 'Во время запроса произошла ошибка');
      }
    }
  },

  mutations: {
    SET_ESBD_ERROR(state, flag) {
      state.esbdError = flag;
    },

    SET_REQUEST_ERROR(state, flag) {
      state.requestError = flag;
    },

    SET_ERROR_MESSAGE(state, message) {
      state.errorMessage = message;
    }
  }
};